import React from 'react';
import ReactDOM from 'react-dom/client';
import { MusicPlayer } from './MusicPlayer';

const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<React.StrictMode>
    {/* <Player>
    </Player> */}
    <MusicPlayer></MusicPlayer>
  </React.StrictMode>);